import { render, staticRenderFns } from "./StandardHeader.vue?vue&type=template&id=6c1c5f69&scoped=true"
import script from "./StandardHeader.vue?vue&type=script&lang=js"
export * from "./StandardHeader.vue?vue&type=script&lang=js"
import style0 from "./StandardHeader.vue?vue&type=style&index=0&id=6c1c5f69&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1c5f69",
  null
  
)

export default component.exports